export const getFoundationServiceSchemeAndHost = (): string|undefined => {
    if (window.location.hostname !== "localhost") {
        return `${window.location.protocol}//${window.location.host}`;
    }

    const foundationServiceHost = process.env.REACT_APP_FS_HOST as string;
    if(!foundationServiceHost) {
        console.error("When running this service locally, you must supply the scheme/host (without trailing slash) for the Foundation Service as REACT_APP_FS_HOST.");
        return undefined;
    }

    return foundationServiceHost;
}